import { useContext, useEffect, useRef, useState } from 'react';
import { AuthContext } from '../Auth/AuthProvider';
import { Link } from 'react-router-dom';
import {faBagShopping, faCartArrowDown, faUserCircle} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from "./../assets/logo.png";
export default function Navbar() {
    const [isMobileDropdownVisible, setIsMobileDropdownVisible] = useState(false);
    const [isProfileDropDownMenu,setIsProfileDropDownMenu] = useState(false);
    const auth = useContext(AuthContext);
    const mobileMenuRef = useRef(null);
    const profileMenuRef = useRef(null);
    useEffect(() => {
      auth.getData();
      function handleClickOutside(event) {
        if(mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
          setIsMobileDropdownVisible(false);
        }
        if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
          setIsProfileDropDownMenu(false);
        }
      }
      document.addEventListener("pointerdown", handleClickOutside);
      return () => {
        document.removeEventListener("pointerdown", handleClickOutside);
      };
    }, []);
    return (
      <div className="bg-neutral-900 border-b-1 border-neutral-700">
        {/* Mobile View */}
        <div className="flex justify-between items-center md:hidden w-full">
          <Link to="/">
            <div className='text-white text-3xl px-3 font-bold text-shadow-xl italic'>
              <img src={logo} alt="Logo" width={100} className='py-2' />
            </div>
          </Link>
          <div className='flex flex-row'>
            <Link to="/products" onClick={() => setIsMobileDropdownVisible(false)}>
              <div className='font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>
                <FontAwesomeIcon icon={faBagShopping} className='text-white px-2' />
              </div>
            </Link>
            {Object.keys(auth.userData).length > 0 ? (
              <>
                <div>
                  <Link to="/users/cart" onClick={() => setIsMobileDropdownVisible(false)}>
                    <div className='mr-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>
                      <FontAwesomeIcon icon={faCartArrowDown} className='text-white px-2' />
                    </div>
                  </Link>
                </div>
              </>
            ):(<></>)}
            <div ref={mobileMenuRef} className='relative md:hidden'>
              <FontAwesomeIcon icon={faUserCircle} onClick={() => setIsMobileDropdownVisible(prev=>!prev)} className="text-2xl text-white mr-3 hover:cursor-pointer" />
              <div className={`${isMobileDropdownVisible ? 'flex' : 'hidden'} w-40 md:hidden flex-col absolute top-7 right-0 z-10 bg-neutral-900 border border-neutral-700 rounded-lg shadow-lg`} id='mobile-dropdown'>
                {Object.keys(auth.userData).length > 0 ? (
                  <>
                    <Link to="/orders" onClick={() => setIsMobileDropdownVisible(false)}>
                    <div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>
                      Orders
                    </div>
                    </Link>
                    <Link to="/users/profile" onClick={() => setIsMobileDropdownVisible(false)}><div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>Profile</div></Link>
                    <Link to="/logout" onClick={() => setIsMobileDropdownVisible(false)}><div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>Logout</div></Link>
                  </>
                ) : (
                  <>
                    <Link to="/users/register" onClick={() => setIsMobileDropdownVisible(false)}><div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>Sign Up</div></Link>
                    <Link to="/users/login" onClick={() => setIsMobileDropdownVisible(false)}><div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>Login</div></Link>
                  </>
                )}
              </div>
            </div>  
          </div>
        </div>
        {/* Desktop view */}
        <div className="hidden md:flex justify-between items-center">   
          <Link to="/">
            <div className='text-white text-3xl px-3 font-bold text-shadow-xl italic'>
              <img src={logo} alt="Logo" width={100} />
            </div>
          </Link>
          <div className='flex gap-5 transition-color duration-700'>
            <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer rounded-lg text-white transition-all duration-500'>
              <Link to="/">
                Home
              </Link>
            </div>
            <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer rounded-lg text-white transition-all duration-500'>
              <Link to="/products">
                Products
              </Link>
            </div>
            <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer rounded-lg text-white transition-all duration-500'>
              <Link to="/about-us">
                About Us
              </Link>
            </div>
          </div>
          <div className='flex gap-5 items-center p-2 transition-color duration-700'>
            {Object.keys(auth.userData).length > 0 ? (
              <>
                <div>
                  <Link to="/users/cart" onClick={() => setIsMobileDropdownVisible(false)}>
                    <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>
                      <FontAwesomeIcon icon={faCartArrowDown} className='text-white px-2' />
                      Cart
                    </div>
                  </Link>
                </div>
                <div ref={profileMenuRef} className="relative">
                  <FontAwesomeIcon icon={faUserCircle} onClick={() => setIsProfileDropDownMenu(prev=>!prev)} className='text-2xl hover:cursor-pointer text-white' />
                  <div className={`${isProfileDropDownMenu? 'flex':'hidden'} flex-col absolute right-0 mt-2 w-40 bg-neutral-900 border border-neutral-700 rounded-lg shadow-lg z-10`}>
                    <Link to="/orders">
                      <div className='px-4 py-2 font-bold hover:bg-amber-700 hover:cursor-pointer text-white'>
                      Orders
                      </div>
                    </Link>
                    <Link to="/users/profile"><div className='px-4 py-2 hover:bg-amber-700 font-bold hover:cursor-pointer text-white transition-all duration-500'>Profile</div></Link>
                    <Link to="/logout"><div className='px-4 py-2 hover:bg-amber-700 font-bold hover:cursor-pointer text-white transition-all duration-500'>Logout</div></Link>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer rounded-lg text-white transition-all duration-500'><Link to="/users/register">Sign Up</Link></div>
                <div className='p-2 font-bold hover:bg-amber-700 hover:cursor-pointer rounded-lg text-white transition-all duration-500'><Link to="/users/login">Login</Link></div>
              </>
            )}
        </div>
      </div>
    </div>
  );
}
